import { render, staticRenderFns } from "./SignUpStepSurvey.vue?vue&type=template&id=0b6e1b5f"
import script from "./SignUpStepSurvey.vue?vue&type=script&lang=js"
export * from "./SignUpStepSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports